import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step4 } from '../../../../../shared/models/component-messages/mapaRE/step4';
import { ArrayPopTools } from '../../../../../shared/services/array-pop-tools';
import { FormUtilsService } from '../../../../../shared/services/form-utils.service';
import { ObjectToJsonStepperCreatorService } from '../../../../../shared/services/object-to-json-stepper-creator.service';
import { Rectificatif } from '../../models/Rectificatif';

@Component({
  selector: 'app-step4',
  templateUrl: './step4.component.html'
})
export class Step4Component implements OnInit {

  @Input() rectificatif: Rectificatif;
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;



	@Input() uid = '';
  @Input() linkForRouter: string;
  public step4 = new Step4();

	constructor() { }


  ngOnInit(): void {
  }

  public getUid() {
		return this.uid;
	}

	addtypeInfosRectif() {
		//this.rectificatif.infosRectif.push(new TypeInfosRectif());
		this.rectificatif.infosRectif.push(new String());
	}

  removetypeInfosRectif(i){
	  if(i > 0)
		ArrayPopTools.pop(this.rectificatif.infosRectif, i, this.parentForm, this.getUid());
	}

}
